class MFRVideoPlayer {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.selectors = {
      videoPlayer: "#video-player",
      closeButton: ".close-overlay"
    }

    this.init();
  }

  init() {
    this.$videoPlayer = this.$element.find(this.selectors.videoPlayer);
    this.$videoOverlay = this.$element;
    this.$closeButton = this.$element.find(this.selectors.closeButton);

    this.$videoOverlay.on("click", this.__handleOverlayClick.bind(this));
    this.$closeButton.on("click", this.__handleCloseButtonClick.bind(this));
  }

  __handleCloseButtonClick() {
    const video = this.$videoPlayer.get(0);

    if(video) {
      this.$element.removeClass("active");
      video.pause();
      this.$videoPlayer.find("source").remove();
      video.load();
    }
  }

  __handleOverlayClick(e) {
    if($(e.target).hasClass("video-overlay")) {
      this.$closeButton.click();
    }
  }
}